import { render, staticRenderFns } from "./moreBed.vue?vue&type=template&id=4eefe682&scoped=true"
import script from "./moreBed.vue?vue&type=script&lang=js"
export * from "./moreBed.vue?vue&type=script&lang=js"
import style0 from "./moreBed.vue?vue&type=style&index=0&id=4eefe682&prod&lang=scss&scoped=true"
import style1 from "./moreBed.vue?vue&type=style&index=1&id=4eefe682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eefe682",
  null
  
)

export default component.exports